var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.6668,
    height: 36.6668,
    rx: 9,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3638_172941)",
    filter: "url(#filter0_ii_3638_172941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6702 8.34521C14.5659 8.34603 13.6722 9.24042 13.673 10.3425C13.6722 11.4446 14.5667 12.339 15.671 12.3398H17.6691V10.3433C17.6699 9.24123 16.7753 8.34684 15.6702 8.34521C15.671 8.34521 15.671 8.34521 15.6702 8.34521V8.34521ZM15.6702 13.6724H10.3437C9.23943 13.6733 8.34489 14.5676 8.34571 15.6697C8.34407 16.7718 9.23862 17.6662 10.3429 17.6679H15.6702C16.7745 17.667 17.6691 16.7727 17.6682 15.6706C17.6691 14.5676 16.7745 13.6733 15.6702 13.6724Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3226 15.6697C28.3234 14.5676 27.4288 13.6733 26.3245 13.6724C25.2202 13.6733 24.3257 14.5676 24.3265 15.6697V17.6679H26.3245C27.4288 17.667 28.3234 16.7727 28.3226 15.6697ZM22.9953 15.6697V10.3425C22.9961 9.24123 22.1023 8.34684 20.998 8.34521C19.8937 8.34603 18.9992 9.24042 19 10.3425V15.6697C18.9984 16.7718 19.8929 17.6662 20.9972 17.6679C22.1015 17.667 22.9961 16.7727 22.9953 15.6697Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.998 28.3225C22.1023 28.3217 22.9969 27.4273 22.9961 26.3252C22.9969 25.2231 22.1023 24.3287 20.998 24.3279H19V26.3252C18.9992 27.4265 19.8937 28.3209 20.998 28.3225ZM20.998 22.9944H26.3253C27.4296 22.9936 28.3242 22.0992 28.3234 20.9971C28.325 19.895 27.4304 19.0007 26.3261 18.999H20.9989C19.8945 18.9998 19 19.8942 19.0008 20.9963C19 22.0992 19.8937 22.9936 20.998 22.9944Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3457 20.9968C8.34489 22.0989 9.23943 22.9933 10.3437 22.9941C11.448 22.9933 12.3426 22.0989 12.3418 20.9968V18.9995H10.3437C9.23943 19.0003 8.34489 19.8947 8.3457 20.9968ZM13.673 20.9968V26.324C13.6714 27.4262 14.5659 28.3205 15.6702 28.3222C16.7745 28.3214 17.6691 27.427 17.6682 26.3249V20.9984C17.6699 19.8963 16.7753 19.002 15.671 19.0003C14.5659 19.0003 13.6722 19.8947 13.673 20.9968C13.673 20.9968 13.673 20.9976 13.673 20.9968Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3638_172941",
    x: 8.3457,
    y: 6.82748,
    width: 19.9766,
    height: 23.0115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3638_172941"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.51725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3638_172941",
    result: "effect2_innerShadow_3638_172941"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3638_172941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9771,
    height: 19.9771,
    fill: "white",
    transform: "translate(8.3457 8.34473)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.6254687cdd6d5af6961202d6b43712c6.svg";
export { ForwardRef as ReactComponent };